module.exports = __webpack_public_path__ + "static/media/study 201022.df69f9e6.png";